import { type ReactNode } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useIsAuthenticated } from "react-auth-kit";
import { useAuthUser } from "react-auth-kit";
import { useSyncTimezone } from "hooks/useSyncTimezone";

type SafeRequireAuthProps = {
  children: ReactNode;
  loginPath: string;
};

  export const SafeRequireAuth = ({
    children,
    loginPath,
  }: SafeRequireAuthProps) => {
    const isAuthenticated = useIsAuthenticated();
    const auth = useAuthUser();
    const location = useLocation();
    useSyncTimezone();

    if (!isAuthenticated()) {
      const userType = auth()?.userType;
      const fallbackType = localStorage.getItem("lastAccountType") || "talent";
      const redirectType = userType || fallbackType;

      return (
        <Navigate
          to={loginPath.replace(":type", redirectType)}
          state={{ from: location }}
          replace
        />
      );
    }

    return <>{children}</>;
  };
  

